module.exports = __webpack_public_path__ + "img/Flag_of_Tokelau.6dbbec4b.svg";